import type { Dict } from "../core.js";
import type { platform as vi } from "../vi/platform.js";

export const platform: Dict<typeof vi> = {
  title: "Collection history",
  subtitle: "Sync runs, schema drift, read cursors, and who did what.",
  "tab.runs": "Runs",
  "tab.drift": "Schema drift",
  "tab.cursors": "Cursors",
  "tab.audit": "Audit log",
  loadFailed: "Couldn't load platform data.",
  empty: "No rows yet.",

  "col.source": "Source",
  "col.stream": "Stream",
  "col.trigger": "Trigger",
  "col.result": "Result",
  "col.rows": "Rows",
  "col.queued": "Queued",
  "col.finished": "Finished",
  "col.status": "Status",
  "col.diff": "Drifted columns",
  "col.observedAt": "Observed",
  "col.highWatermark": "Read up to",
  "col.lastSuccess": "Last success",
  "col.safetyWindow": "Safety window",
  "col.at": "When",
  "col.actor": "Who",
  "col.action": "Action",
  "col.entity": "Entity",
  "col.reason": "Reason",
  system: "system",
  "auditNote.pre": "This is the ",
  "auditNote.strong": "business",
  "auditNote.post":
    " log: who mapped a plan, who granted an account, who requested a sync. Job start / retry / failure events live in the « Runs » tab — putting them here would bury what matters under thousands of machine-generated rows.",

  "run.loadFailed": "Couldn't load this run.",
  "run.back": "← Operations",
  "run.watching": "watching…",
  "run.rowsWritten": "Rows written",
  "run.requestedBy": "Requested by",
  "run.scheduled": "schedule",
  "run.requestedAt": "Queued at",
  "run.startedAt": "Started at",
  "run.finishedAt": "Finished at",
  "run.alreadyRunning.strong": "Not an error.",
  "run.alreadyRunning.body":
    " Another run for the same source and stream is in progress, so this one was skipped — the advisory lock did its job.",
  "run.note.pre": "A run is ",
  "run.note.strong": "history",
  "run.note.mid":
    ", not a lock. The real lock is a Postgres advisory lock, released automatically when the connection dies — so a stuck « running » row blocks nothing, it just lies, and the sweeper marks it ",
  "run.note.post": " after a few minutes.",
  "errorCode.UNREACHABLE": "Couldn't connect to the source (refused, wrong host, or network unreachable).",
  "errorCode.AUTH_FAILED": "The source rejected the credentials — check the user/password in the connection string.",
  "errorCode.TIMEOUT": "The source didn't respond within the allowed time.",
  "errorCode.QUERY_FAILED": "A query against the source failed.",
  "errorCode.CONFIG_REJECTED":
    "The source rejected how the hub connects (usually a connection pooler) — try the direct host without `-pooler`.",
  "errorCode.SCHEMA_DRIFT": "The source schema drifted from the contract — the hub stopped pulling data to avoid writing wrong numbers.",
  "errorCode.VALIDATION_ERROR": "Data returned by the source failed validation.",
  "errorCode.ALREADY_RUNNING": "Another run is already in progress for this source.",
  "errorCode.LOST": "The worker never reported the run finishing — it was marked as lost.",
  "errorCode.technical": "Technical detail",
};
